import {
  DEFAULT_MEMBER_UI_LOCALE,
  isMemberUiLocale,
  MEMBER_UI_LOCALES,
  type MemberUiLocale,
} from "./memberUiLocales.js";

/** Locales members can pick in settings (stored on user_settings.locale). */
export const UI_LOCALES = MEMBER_UI_LOCALES;
export { MEMBER_UI_LOCALES, type MemberUiLocale };

export type UiLocale = MemberUiLocale;

/**
 * Locales with a full message bundle under src/messages/{locale}/.
 * Add entries here as translations ship; until then resolveMessageLocale falls back to en.
 */
export const MESSAGE_LOCALES = ["en"] as const;

export type MessageLocale = (typeof MESSAGE_LOCALES)[number];

export const DEFAULT_MESSAGE_LOCALE: MessageLocale = "en";

export const LOCALE_COOKIE_NAME = "sukha-locale";

/** One year — preference cookie, not session auth. */
export const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function isUiLocale(value: string): value is UiLocale {
  return isMemberUiLocale(value);
}

export function isMessageLocale(value: string): value is MessageLocale {
  return (MESSAGE_LOCALES as readonly string[]).includes(value);
}

/**
 * Maps a member's requested locale to the bundle we can actually load.
 * Unsupported or not-yet-translated locales fall back to English without crashing.
 */
export function resolveMessageLocale(
  requested: string | undefined | null
): MessageLocale {
  if (requested && isMessageLocale(requested)) {
    return requested;
  }
  return DEFAULT_MESSAGE_LOCALE;
}

/** Normalize member UI locale for focus messages / settings. */
export function normalizeUiLocale(
  requested: string | undefined | null
): UiLocale {
  if (requested && isUiLocale(requested)) {
    return requested;
  }
  return DEFAULT_MEMBER_UI_LOCALE;
}
